import React from 'react'

export default function MinMax(props) {
    return (
        <div className="flexed-section-v1 min-max-range">
            {props.children}
        </div>
    )
}
